<div>


    <!-- <ion-button (click)="setAndre()">setAndre</ion-button>
   <ion-button (click)="downloadJson()">generate</ion-button>
    <ion-button [href]="downloadJsonHref">Download</ion-button>
    <ion-button (click)="resetCommerciali()">Reset commerciali</ion-button>
    <ion-button (click)="resetContratti()">Reset contratti</ion-button>
    <ion-button (click)="deleteBonus()">Delete Bonus</ion-button>
    <ion-button (click)="calcolaPianoCariera()">Calcolo Piano Carriera 2020</ion-button>
    <ion-button (click)="attivaContratti()">Attiva Contratti</ion-button>
    <ion-button (click)="importDati()">Import Dati</ion-button>-->
    <!-- <ion-button (click)="importFaq()">Import Dati</ion-button>
     <ion-button (click)="setEmails()">Set emails</ion-button>  -->
    <!--<ion-button (click)="changeProducts()">Change products</ion-button> -->


    <!-- <ion-button (click)="noCommercialContracts()">contratti senza commerciali</ion-button>
    <ion-button (click)="noClientContract()">contratti senza clienti</ion-button> -->
 <!--  <ion-button (click)="resetCommerciali()">Reset commerciali</ion-button>
    <ion-button (click)="resetContratti()">Reset contratti</ion-button>
    <ion-button (click)="deleteBonus()">Delete Bonus</ion-button>
    <ion-button (click)="calcolaPianoCariera()">Calcolo Piano Carriera 2020</ion-button>
    <ion-button (click)="attivaContratti()">Attiva Contratti</ion-button>

    <ion-button (click)="setNomi()">Reset Nomi persone</ion-button>-->


</div>
<div class="menu-grid-container">
    <div class="glass-blurred-background menu-box center-content" (click)="openPage('/admin/home2')">
        <img class="block-image svg-white" src="./assets/imgs/squadre.svg">
        <h2 class="text-center"><br>
            <div class="ion-text-nowrap">AMMINISTRATORE</div>
        </h2>
    </div>
    <div class="glass-blurred-background menu-box center-content" (click)="openPage('/agent/home2')">
        <img class="block-image svg-white" src="./assets/imgs/io_commerciale.svg">
        <h2 class="text-center"><br>
            <div class="ion-text-nowrap">COMMERCIALE</div>
        </h2>
    </div>
    <div class="glass-blurred-background menu-box center-content" (click)="openPage('/agent/home3')">
        <img class="block-image svg-white" src="./assets/imgs/io_commerciale.svg">
        <h2 class="text-center"><br>
            <div class="wrap-text">CLIENTE</div>
        </h2>
    </div>
    <div class="glass-blurred-background menu-box center-content" (click)="openPage('/career')">
        <img class="block-image svg-white" src="./assets/imgs/carriera.svg">
        <h2 class="text-center">MIA <br>
            <div class="wrap-text">CARRIERA</div>
        </h2>
    </div>
</div>


<!-- <ion-row class="dashboard-row"> -->

<!-- <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/admin/home2')">
  <div class="dash-widget">
    <div class="dash-widget-icon">
      <span class="custom-icon-dashboard-client-icon"></span>
    </div>
    <div class="dash-widget-info">

      <p class="dash-text">Amministratore</p>
    </div>
  </div>
</ion-col> -->

<!-- <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/agent/home2')">
  <div class="dash-widget">
    <div class="">
      <span class="ds-dashicon io_commerciale"></span>
    </div>
    <div class="dash-widget-info">
      <p class="dash-text">Commerciale</p>
    </div>
  </div>
</ion-col> -->

<!-- <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/agent/home3')">
  <div class="dash-widget">
    <div class="">
      <span class="ds-dashicon io_commerciale"></span>
    </div>
    <div class="dash-widget-info">
      <p class="dash-text">Cliente</p>
    </div>
  </div>
</ion-col>

<ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/career')">
  <div class="dash-widget">
    <div class="">
      <span class="ds-dashicon carriera"></span>
    </div>
    <div class="dash-widget-info">
      <p class="dash-text">Mia Carriera</p>
    </div>
  </div>
</ion-col> -->

<!-- </ion-row> -->

<!-- <ion-row *ngIf="page == 2" class="dashboard-row">

  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/users')">
    <div class="dash-widget">
      <div class="dash-widget-icon">
        <span class="custom-icon-dashboard-client-icon"></span>
      </div>
      <div class="dash-widget-info">
        <h4 class="dash-amount"></h4>
        <p class="dash-text">Elenco</p>
      </div>
    </div>
  </ion-col>

  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/admin')">
    <div class="dash-widget">
      <div class="dash-widget-icon">
        <span class="custom-icon-dashboard-employee-icons"></span>
      </div>
      <div class="dash-widget-info">
        <h4 class="dash-amount"></h4>
        <p class="dash-text">Azioni</p>
      </div>
    </div>
  </ion-col>

  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/admin')">
    <div class="dash-widget">
      <div class="dash-widget-icon">
        <span class="custom-icon-dashboard-invoice-icons"></span>
      </div>
      <div class="dash-widget-info">
        <h4 class="dash-amount"></h4>
        <p class="dash-text">Statistiche</p>
      </div>
    </div>
  </ion-col>

</ion-row>

<app-agent-home-menu *ngIf="page == 3"></app-agent-home-menu>



<div *ngIf="page != 1" size="6" class="bottom-btn" (click)="backClicked()">
  <p class="dash-text">
    <span class="custom-icon-dashboard-invoice-icon">&lt;</span>
    Amministratore
  </p>
</div> -->
